import { IThoiKhoaBieuItemSelectRequest } from "../../../models/request/thoi-khoa-bieu/IThoiKhoaBieuItemSelectRequest";
import { pl_tkb_chitiet_view } from "../../../models/response/thoi-khoa-bieu/pl_tkb_chitiet";
import { IActionTypeBase } from "../IActionTypeBase";

export enum eIThoiKhoaBieuViewActionTypeIds {
    CHANGE_VIEW_MODE = "THOIKHOABIEU_VIEW_CHANGE_VIEW_MODE",
    CHANGE_REQUEST = "THOIKHOABIEU_VIEW_CHANGE_REQUEST",
    LOAD_START = "THOIKHOABIEU_VIEW_LOAD_START",
    LOAD_SUCCESS = "THOIKHOABIEU_VIEW_LOAD_SUCCESS",
    LOAD_ERROR = "THOIKHOABIEU_VIEW_LOAD_ERROR",
}
export interface IThoiKhoaBieuViewChangeViewMode extends IActionTypeBase<eIThoiKhoaBieuViewActionTypeIds.CHANGE_VIEW_MODE, "lop" | "giao_vien" | "phong_hoc"> { }
export interface IThoiKhoaBieuViewChangeRequest extends IActionTypeBase<eIThoiKhoaBieuViewActionTypeIds.CHANGE_REQUEST, IThoiKhoaBieuItemSelectRequest> { }

export interface IThoiKhoaBieuViewLoadStart extends IActionTypeBase<eIThoiKhoaBieuViewActionTypeIds.LOAD_START, IThoiKhoaBieuItemSelectRequest> { }
export interface IThoiKhoaBieuViewLoadSuccess extends IActionTypeBase<eIThoiKhoaBieuViewActionTypeIds.LOAD_SUCCESS, pl_tkb_chitiet_view[]> { }
export interface IThoiKhoaBieuViewLoadError extends IActionTypeBase<eIThoiKhoaBieuViewActionTypeIds.LOAD_ERROR, string> { }

export type IThoiKhoaBieuViewActionTypes = IThoiKhoaBieuViewChangeViewMode |
    IThoiKhoaBieuViewChangeRequest |
    IThoiKhoaBieuViewLoadStart | IThoiKhoaBieuViewLoadSuccess | IThoiKhoaBieuViewLoadError